export default "__VITE_ASSET__RXLYPAxe__"